
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/huodong",
      function () {
        return require("private-next-pages/huodong/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/huodong"])
      });
    }
  